<template>
    <v-content>
        <v-container>
            <v-layout align-center justify-center fill-height>
                <v-flex xs12 sm7 md6 lg5 xl3>
                    <h2 style="text-align: center;">
                        <strong>
                            <span style=" text-align: center;">{{$t('msg_invitation_01')}}</span>
                        </strong>
                    </h2>
                    <p style="text-align: center;">
                        <span style="background-color: #2b2301; color: #fff; display: inline-block; padding: 3px 10px; font-weight: bold; border-radius: 5px;">{{ info_invitation.invitation.park_name }}</span>
                        <br>
                        <img
                            :src="info_invitation.invitation.park_logo"
                            width="150px"
                        >
                    </p>
                    <p style="text-align: center;">{{$t('msg_invitation_02')}}</p>
                    <p style="text-align: center;"><strong>{{$t('fecha_hora')}}: {{ info_invitation.invitation.dateInv }}  {{info_invitation.invitation.timeInv}}</strong></p>
                    <p v-if="info_invitation.invitation.typeInv === 2" style="text-align: center;"><strong>{{$t('fecha_expiracion')}}: {{ info_invitation.invitation.expiration }}</strong></p>
                    <p v-if="info_invitation.invitation.typeInv === 2"  style="text-align: center;"><strong>{{$t('dias_validos')}}</strong></p>
                    <ul v-if="info_invitation.invitation.typeInv === 2" style="list-style: none; text-align: center;">
                        <li v-if="info_invitation.invitation.diary.includes('0') === true">
                            {{ $t('Lunes') }}
                        </li>
                        <li v-if="info_invitation.invitation.diary.includes('1') === true">
                            {{ $t('Martes') }}
                        </li>
                        <li v-if="info_invitation.invitation.diary.includes('2') === true">
                            {{ $t('Miercoles') }}
                        </li>
                        <li v-if="info_invitation.invitation.diary.includes('3') === true">
                            {{ $t('Jueves') }}
                        </li>
                        <li v-if="info_invitation.invitation.diary.includes('4') === true">
                            {{ $t('Viernes') }}
                        </li>
                        <li v-if="info_invitation.invitation.diary.includes('5') === true">
                            {{ $t('Sabado') }}
                        </li>
                        <li v-if="info_invitation.invitation.diary.includes('6') === true">
                            {{ $t('Domingo') }}
                        </li>
                    </ul>
                    <v-card>
                        <v-toolbar class="mb-auto" dark color="primary">
                            <v-toolbar-title style="text-align: center;">
                                {{$t('qr_code')}}
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                        <v-card-text class="mt-4">
                            <v-row>
                                <v-flex xs12>
                                    <v-img
                                            class="centrado"
                                            :src="url"
                                            width="200"
                                            height="200"
                                    >
                                    </v-img>
                                    <p style="text-align: center;">
                                        <strong><span style="color: #000000;">{{$t('codigo')}}:{{ codigo_qr }}</span></strong>
                                    </p>
                                    <div v-if="info_invitation.confirmed === false" style="text-align: center;">
                                        <v-btn
                                                class="white--text"
                                                @click="confirmarAsistencia()"
                                                :loading="loading"
                                                color="primary"
                                        >
                                            <v-icon left dark>check</v-icon>{{$t('confirmar_asistencia')}}
                                        </v-btn>
                                    </div>
<!--                                    <div style="text-align: center;">-->
<!--                                        <a :href="urlWallet">-->
<!--                                            <v-img-->
<!--                                                    class="centrado"-->
<!--                                                    border="0"-->
<!--                                                    :src="require('../assets/wallet.png')"-->
<!--                                                    width="150"-->
<!--                                                    contain>-->
<!--                                            </v-img>-->
<!--                                        </a>-->
<!--                                    </div>-->
<!--                                    <br>-->
<!--                                    <div style="text-align: center;">-->
<!--                                        <v-icon>place</v-icon>-->
<!--                                        <a :href="info_invitation.urlmap">{{$t('ubicacion_maps')}}</a>-->
<!--                                    </div>-->
                                </v-flex>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </v-content>
</template>

<script>
    import { mapState } from 'vuex'
    export default {
        name: "qr_code_park",
        data(){
            return{
                url: "https://api.qrserver.com/v1/create-qr-code/?data=" + this.$route.params['qrcode'] + "&ecc=M&margin=20&size=400x400",
                codigo_qr: this.$route.params['qrcode'],
                url_confirmar: "https://empresa-service.intrare.app/InvitationPark/confirm/no_permission/" + this.$route.params['qrcode'],
                urlWallet: "https://empresa-service.intrare.app/wallet/create/" + this.$route.params['qrcode'],
                info_invitation: [],
                loading: false
            }
        },
        created: async function (){
            await this.get_info_invitation()
        },
        computed: {
            ...mapState(['language'])
        },
        methods:{
            get_info_invitation(){
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/InvitationPark/no_permission/' + this.$route.params['qrcode'],
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language,
                    },
                };
                axios(config)
                    .then(result => {
                        this.info_invitation = result.data
                        console.log(this.info_invitation)
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            confirmarAsistencia () {
                this.loading = true
                const config = {
                    method: 'PUT',
                    url: 'https://empresa-service.intrare.app/InvitationPark/confirm/no_permission/' + this.$route.params['qrcode'],
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
                axios(config)
                    .then(ok => {
                        this.loading = false
                        this.get_info_invitation()
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_message', this.$t('msg_invitacion_confirmada'))
                    })
                    .catch(error => {
                        this.loading = false
                        console.log(error)
                    })
                    .finally(() => (this.loading = false))
            }
        }
    }
</script>

<style scoped>
    .centrado{
        display:block;
        margin-left: auto;
        margin-right: auto;
    }
</style>
